<template>
    <div ref="chart" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'CamembertChart',
    props: {
        data: {
            default: () => []
        },
        title: {
            type: String,
            default: 'titre'
        },
        description: {
            type: String,
            default: ''
        },
        height: {
            type: String,
            default: '100%'
        },
        width: {
            type: String,
            default: '100%'
        }
    },
    mounted() {
        this.initChart();
    },
    methods: {
        initChart() {
            const chartDom = this.$refs.chart;
            const myChart = echarts.init(chartDom);

            const option = {
                title: {
                    text: this.title,
                    subtext: this.description,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                series: [
                    {
                        name: 'Licences ouvertes',
                        type: 'pie',
                        radius: '50%',
                        center: window.screen.availWidth >= 900 ? ['70%', '50%'] : ['50%', '50%'],
                        data: this.data,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            if (window.screen.availWidth >= 900) {
                option.legend = {
                    type: 'scroll',
                    orient: 'vertical',
                    left: 'left'
                };
            }

            option && myChart.setOption(option);
        },
        updateChart(newData) {
            const chartDom = this.$refs.chart;
            const myChart = echarts.init(chartDom);

            const option = {
                title: {
                    text: this.title,
                    subtext: this.description,
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)'
                },
                series: [
                    {
                        name: 'Licences ouvertes',
                        type: 'pie',
                        radius: '60%',
                        center: window.screen.availWidth >= 900 ? ['70%', '50%'] : ['50%', '50%'],
                        data: newData,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };

            if (window.screen.availWidth >= 900) {
                option.legend = {
                    type: 'scroll',
                    orient: 'vertical',
                    left: 'left'
                };
            }

            option && myChart.setOption(option);
        }
    },
    watch: {
        data: {
            handler(newData) {
                this.updateChart(newData);
            },
            deep: true
        }
    }
};
</script>

<style scoped>
/* Vous pouvez ajouter des styles ici si nécessaire */
</style>
